import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import Metatags from '@components/common/Metatags';
const PAGESSIZES = {
    base: 12,
    tier1: 25,
    tier2: 16,
};
const ListingPagination = (props) => {
    const { progress, count, pageMetaTags, category, pageSize } = useSelector((state) => state.search);
    const originalSize = pageSize;
    const progressSize = pageSize;
    const [pagination, setPagination] = useState([]);
    const getAdditionalMeta = useCallback(() => {
        let list = [];
        if (category && (category === null || category === void 0 ? void 0 : category.url) && pagination.length < 1) {
            list.push(React.createElement("link", { key: "canonical", href: `${location.origin + (category === null || category === void 0 ? void 0 : category.url)}` }));
        }
        else {
            let currentIndex = pagination.findIndex((page) => page.current);
            if (currentIndex) {
                let currentPage = pagination[currentIndex];
                list.push(React.createElement("link", { key: "canonical", href: currentPage === null || currentPage === void 0 ? void 0 : currentPage.url }));
                let nextPage = pagination[currentIndex + 1];
                let prevPage = pagination[currentIndex - 1];
                if (!!prevPage) {
                    list.push(React.createElement("link", { key: "prev", rel: "prev", href: prevPage === null || prevPage === void 0 ? void 0 : prevPage.url }));
                }
                if (!!nextPage) {
                    list.push(React.createElement("link", { key: "next", rel: "next", href: nextPage === null || nextPage === void 0 ? void 0 : nextPage.url }));
                }
            }
        }
        return list;
    }, [pagination]);
    useEffect(() => {
        let paging = [];
        if (!category || count > originalSize) {
            let pageIndex = 0;
            for (let x = 0; x <= count; x = x + originalSize) {
                paging[pageIndex] = {
                    displayName: pageIndex + 1,
                    url: `${location.origin + category.url}` + ((pageIndex != 0 && `?start=${x}`) || ''),
                    current: x === progress - progressSize,
                };
                pageIndex++;
            }
        }
        setPagination(paging);
    }, [count, progress, category]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Metatags, { pageMetaTags: pageMetaTags, meta: category.meta, additionalMeta: getAdditionalMeta() }),
        pagination.length > 1 && (React.createElement(React.Fragment, null, createPortal(React.createElement("div", { className: "pagination" }, pagination.map((page, i) => (React.createElement(React.Fragment, { key: i }, page.current ? React.createElement("span", { className: "current-page" }, page.displayName) : React.createElement("a", { href: page.url }, page.displayName))))), document.querySelector('#no-script-pagination'))))));
};
export default ListingPagination;
